import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;
export const LOCATION_HISTORY = `${API_URL}/api/v1/parent/kid-location-history`;

export function locationHistory(data) {
    const {kidId, deviceId,interval, startDate, endDate } = data;
    return axiosInstance({
        url: `${LOCATION_HISTORY}?kidId=${kidId}&deviceId=${deviceId}&interval=${interval}&startDate=${startDate}&endDate=${endDate}&pageNumber=${1}&pageSize=20`,
        method: "GET",
    })
}